//set false to use production server

const USE_LOCAL_SERVER = false;

const LOCAL_SERVER_ASSISTANT = "http://127.0.0.1:5010"
const LOCAL_SERVER_CHANNEL = "http://127.0.0.1:5009"
const LOCAL_SERVER_ORGANIZATION = "http://127.0.0.1:5011"
const LOCAL_SERVER_DOCUMENT = "http://127.0.0.1:5014"

const PROD_SERVER_ASSISTANT = "https://api.obriy.ai/assistant_api";
const PROD_SERVER_CHANNEL = "https://api.obriy.ai/channel_api";
const PROD_SERVER_ORGANIZATION = "https://api.obriy.ai/organization_api";
const PROD_SERVER_DOCUMENT = "https://api.obriy.ai/document_api";

const PROD_SERVER_SOCKET = "https://api.obriy.ai"
const AUTH0_AUDIENCE = "https://sure-api";
const AUTH0_DOMAIN = "obriy.eu.auth0.com"
const AUTH0_CLIENT_ID = "fiXgOKb8GgPG001j3Y5ELxTELImlp0Ff"

const PROD_ADDRESS = "https://sure-admin.obriy.ai"
const LOCAL_ADDRESS = "http://localhost:3000"

const INST_REDIRECT_PATH = "/meta_auth_callback";
const FACEBOOK_REDIRECT_URI= "https://www.facebook.com/connect/login_success.html"
const INST_REDIRECT_URI = USE_LOCAL_SERVER ? `${LOCAL_ADDRESS}${INST_REDIRECT_PATH}` : `${PROD_ADDRESS}${INST_REDIRECT_PATH}`;

const CONFIG = {
    GOOGLE_DRIVE_REDIRECT_PATH: "connection_callback",
    SERVER_ASSISTANT: USE_LOCAL_SERVER ? LOCAL_SERVER_ASSISTANT : PROD_SERVER_ASSISTANT,
    SERVER_CHANNEL: USE_LOCAL_SERVER ? LOCAL_SERVER_CHANNEL : PROD_SERVER_CHANNEL,
    SERVER_DOCUMENT: USE_LOCAL_SERVER ? LOCAL_SERVER_DOCUMENT : PROD_SERVER_DOCUMENT,
    SERVER_ORGANIZATION: USE_LOCAL_SERVER ? LOCAL_SERVER_ORGANIZATION : PROD_SERVER_ORGANIZATION,
    SOCKET_SERVER: USE_LOCAL_SERVER ? LOCAL_SERVER_CHANNEL : PROD_SERVER_CHANNEL,
    SOCKET_ROUTE: "/s_admin_channel",
    AUTH0_AUDIENCE: AUTH0_AUDIENCE,
    AUTH0_DOMAIN: AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: AUTH0_CLIENT_ID,
    INST_REDIRECT_PATH: INST_REDIRECT_PATH,
    INST_REDIRECT_URI: INST_REDIRECT_URI,
    FACEBOOK_REDIRECT_URI: FACEBOOK_REDIRECT_URI,
    SOCKET_IDLE_TIMEOUT: 300000,
    SOCKET_IDLE_CHECK: 30000,
    RPM: 100
};

export default CONFIG;